import { NgIf } from '@angular/common'
import { Component, Inject } from '@angular/core'
import {
    FormBuilder,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms'
import { MatCheckbox } from '@angular/material/checkbox'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { Group, GroupDTO, Permision } from '../../../models/group.interface'
import { Profile } from '../../../models/users.interface'
import { GroupService } from '../../../services/group/group.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ProfileService } from '../../../services/profile/profile.service'
import { AngularDualListBoxModule } from 'angular-dual-listbox'
import { dualListSettings } from '../../../../main'

@Component({
    selector: 'app-group-form',
    standalone: true,
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatCheckbox,
        MatIcon,
        AngularDualListBoxModule,
    ],
    templateUrl: './group-form.component.html',
    styleUrl: './group-form.component.css',
})
export class GroupFormComponent {
    selected: Permision[] = []
    permisions: Permision[] = []
    format = dualListSettings
    group: Group | null = null
    private canWrite: boolean = false
    private userProfile: Profile | null = null

    constructor(
        private fb: FormBuilder,
        private groupService: GroupService,
        private dialogRef: MatDialogRef<GroupFormComponent>,
        private perfilService: ProfileService,
        // private sweetAlert: AlertService,
        @Inject(MAT_DIALOG_DATA) data: { group: Group | null }
    ) {
        this.group = data.group
    }

    ngOnInit(): void {
        this.perfilService.userProfile$.subscribe((profile) => {
            if (profile && this.groupService.hasSpecialAccess(profile)) {
                this.canWrite = true
            }
        })
        this.fetchPermisions()
        if (this.group) {
            this.selected = [...this.group.permisions]
            this.groupForm.patchValue({
                name: this.group.name,
                create: this.group.create,
                delete: this.group.delete,
                update: this.group.update,
                read: this.group.read,
            })
        }
    }

    private fetchPermisions() {
        this.groupService
            .getAllPermisions(this.canWrite)
            .subscribe((permisions) => (this.permisions = permisions))
    }

    closeDialog() {
        this.dialogRef.close()
    }

    groupForm = this.fb.group({
        name: [
            '',
            [
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(20),
            ],
        ],
        create: [false, [Validators.required]],
        delete: [false, [Validators.required]],
        update: [false, [Validators.required]],
        read: [false, [Validators.required]],
    })

    onCreateGroup() {
        if (this.groupForm.status === 'VALID' && !this.group) {
            const values = this.groupForm.value
            const payload: GroupDTO = {
                name: this.groupForm.get('name')?.value ?? '',
                read: values.read ? true : false,
                create: values.create ? true : false,
                delete: values.delete ? true : false,
                update: values.update ? true : false,
                permisions: [...this.selected],
            }
            this.groupService.addGroup(payload).subscribe(() => {
                const msg = `El grupo fue creado <b>CORRECTAMENTE!</b>`
                //   this.sweetAlert.showAlert(msg);
                this.closeDialog()
                this.fetchPermisions()
            })
        }

        if (this.groupForm.status === 'VALID' && this.group) {
            const values = this.groupForm.value
            const payload: Group = {
                id: this.group.id,
                name: this.groupForm.get('name')?.value ?? '',
                read: values.read ? true : false,
                create: values.create ? true : false,
                delete: values.delete ? true : false,
                update: values.update ? true : false,
                permisions: this.selected,
            }
            this.groupService.editGroup(payload).subscribe(() => {
                const msg = `El grupo fue editado <b>CORRECTAMENTE!</b>`
                //   this.sweetAlert.showAlert(msg);
                this.closeDialog()
                this.fetchPermisions()
            })
        }
    }
}
